import React, { useEffect, useState } from "react";
import NavBar from "../components/Navigation/NavBar";
import { getConfig, getConstant, handleHeader } from "../services/functions";
import { BASE_URL } from "../utility/path";
import axios from "axios";
import MainContainer from "../components/MainContainer";
import { useDispatch } from "react-redux";
import "../TnC.css";

const AboutUs = () => {
    const [state, setState] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        handleHeader({...getConstant("ABOUT_US")},dispatch);
        loadData();

    }, []);

    const loadData = async () => {
        console.log('loaddata');

        const data = JSON.parse(localStorage.getItem("aboutus"));

        if (data && data?.length > 0) {
            setState(data);
            return;
        }

        try {
            const config = getConfig();
            const res = await axios.get(`${BASE_URL}/api/aboutus`, config);
            if (res?.data?.paras) {
                localStorage.setItem("aboutus", JSON.stringify(res.data.paras));
                setState(res.data.paras);
            }

        } catch (error) {
            console.log(error?.message)
        }
    }

    return (

        <>
            <NavBar />
            <MainContainer>
                <div className="tnc-page">
                <div className="tnc-hero">
                        <div className="tnc-hero__icon">
                            <i className="fa fa-users" />
                        </div>
                        <h3 className="tnc-hero__title">About Us</h3>
                        {/* <p className="tnc-hero__sub">Last updated: April 2024</p> */}
                </div>
                {state.map((el, index) => (
                     el?.trim()?.length > 0 && (<div key={index} className="tnc-section">
                        <div className="tnc-section__body">
                            <div key={index}>{el}</div>
                        </div>
                      </div>)  
                    ))}
                </div>
            </MainContainer>
        </>
    );
};

export default AboutUs;
